export default function cardAnswerFeedback(correct, userAnswer) {
  if (correct !== false) return null;
  return userAnswer !== undefined && userAnswer !== null && String(userAnswer).trim()
    ? `You answered '${String(userAnswer).trim()}'`
    : null;
}
